export interface InsightArticle {
  id: string;
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  readTime: string;
  publishedAt: string;
  featured?: boolean;
}

export const insightCategories = [
  "Growth as a system",
  "Performance vs non-paid",
  "ICP & positioning",
  "Retention & lifecycle",
  "Operating models",
  "AI in growth systems",
] as const;

export type InsightCategory = (typeof insightCategories)[number];

export const insights: InsightArticle[] = [
  {
    id: "1",
    slug: "growth-is-not-a-campaign",
    title: "Growth is not a campaign — it's a system",
    category: "Growth as a system",
    excerpt:
      "Why treating growth as a series of disconnected campaigns leads to waste, and how building systems creates compounding returns.",
    readTime: "6 min read",
    publishedAt: "2024-01-15",
    featured: true,
  },
  {
    id: "2",
    slug: "the-icp-trap",
    title: "The ICP trap: Why most B2B companies get positioning wrong",
    category: "ICP & positioning",
    excerpt:
      "Your ideal customer profile isn't a demographic. It's a behavior pattern. Here's how to find the customers who actually convert.",
    readTime: "8 min read",
    publishedAt: "2024-01-10",
    featured: true,
  },
  {
    id: "3",
    slug: "paid-vs-organic-false-dichotomy",
    title: "Paid vs organic: The false dichotomy killing your growth",
    category: "Performance vs non-paid",
    excerpt:
      "The best growth systems use both channels strategically. Here's how to build an acquisition engine that doesn't depend on one or the other.",
    readTime: "7 min read",
    publishedAt: "2024-01-05",
    featured: true,
  },
  {
    id: "4",
    slug: "retention-revenue-multiplier",
    title: "Retention as a revenue multiplier, not a defensive metric",
    category: "Retention & lifecycle",
    excerpt:
      "Most companies treat retention as damage control. The best ones use it as their primary growth lever.",
    readTime: "5 min read",
    publishedAt: "2023-12-28",
    featured: true,
  },
  {
    id: "5",
    slug: "building-growth-operating-system",
    title: "Building a growth operating system for mid-sized B2B",
    category: "Operating models",
    excerpt:
      "A practical framework for creating a repeatable, measurable growth engine without enterprise complexity.",
    readTime: "10 min read",
    publishedAt: "2023-12-20",
  },
  {
    id: "6",
    slug: "ai-growth-systems-practical-guide",
    title: "AI in growth systems: A practical guide for operators",
    category: "AI in growth systems",
    excerpt:
      "Cut through the hype. Here's what AI can actually do for your growth stack today, and what's still vaporware.",
    readTime: "9 min read",
    publishedAt: "2023-12-15",
  },
  {
    id: "7",
    slug: "fractional-vs-full-time-growth-leader",
    title: "Fractional vs full-time growth leader: Making the right choice",
    category: "Operating models",
    excerpt:
      "When does fractional leadership make sense? A framework for deciding based on your stage and goals.",
    readTime: "6 min read",
    publishedAt: "2023-12-10",
  },
  {
    id: "8",
    slug: "measuring-growth-beyond-vanity",
    title: "Measuring growth beyond vanity metrics",
    category: "Growth as a system",
    excerpt:
      "The metrics that actually matter for B2B service companies, and how to build dashboards that drive decisions.",
    readTime: "7 min read",
    publishedAt: "2023-12-05",
  },
];

export const getFeaturedInsights = () => insights.filter((i) => i.featured);

export const getInsightsByCategory = (category: string) =>
  insights.filter((i) => i.category === category);
